import React from "react"
import kopyLogo from "../assets/kopy-logo-square.png"

export const LoadingScreen = () => {
	return (
		<div
			style={{
				height: "100%",
				width: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<img
				style={{
					width: "4rem",
					height: "4rem",
					borderRadius: "0.5rem",
				}}
				src={kopyLogo}
				className="shimmer"
			/>
			<style>{`
				.shimmer {
					-webkit-mask: linear-gradient(90deg,#000 30%,#0006,#000 70%) right/500% 100%;
					background-repeat: no-repeat;
					animation: shimmer 1s infinite;
				}
				
				@keyframes shimmer {
					100% {
						-webkit-mask-position: left
					}
				}
			`}</style>
		</div>
	)
}
